import { render } from "./DoneResearchQuestion.vue?vue&type=template&id=ce3a49e8&scoped=true"
import script from "./DoneResearchQuestion.vue?vue&type=script&lang=js"
export * from "./DoneResearchQuestion.vue?vue&type=script&lang=js"

import "./DoneResearchQuestion.vue?vue&type=style&index=0&id=ce3a49e8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ce3a49e8"

export default script